import { z } from '@/utils/zod'

import { OAuthBaseAuthProviderSchema } from './OAuthBaseAuthProvider'

export const GoogleAuthProviderTypeSchema = z.literal('google')

export type GoogleAuthProviderType = z.infer<typeof GoogleAuthProviderTypeSchema>

export const GoogleAuthProviderSchema = OAuthBaseAuthProviderSchema.extend({
    type: GoogleAuthProviderTypeSchema,
    emailVerification: z.toggleable({
        requirement: z.enum(['optional', 'required']),
        tokenTtl: z.number().min(1), // seconds
        resendWait: z.number().min(15), // seconds
    }),
})

export type GoogleAuthProvider = z.infer<typeof GoogleAuthProviderSchema>
